import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { RedemptionApplicationsComponent } from './components/redemptions-applications.component';
import { RedemptionApplicationDetailsComponent } from './components/redemptions-application-details.component';

@NgModule({
    declarations: [RedemptionApplicationsComponent, RedemptionApplicationDetailsComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class RedemptionApplicationsModule { }
